export enum EntityDetailDisplayMode {
  Create = 'simx-entity-detail-display-mode--create',
  Edit = 'simx-entity-detail-display-mode--edit',
  View = 'simx-entity-detail-display-mode--view',
  ViewHeading = 'simx-entity-detail-display-mode--view-heading',
}
